import { TextField } from '@mui/material'
import { type FC, useId } from 'react'
import { type Control, Controller } from 'react-hook-form'
import { LabeledField } from 'src/features/labelMaster/form/LabeledField'
import { type LabelMasterForm } from './labelMasterForm'

type Props = {
  control: Control<LabelMasterForm>
}

export const BarcodeId: FC<Props> = ({ control }) => {
  const id = useId()

  return (
    <LabeledField label="呼び出しバーコード番号" htmlFor={id}>
      <Controller
        name="barcodeId"
        control={control}
        rules={{
          pattern: {
            value: /^[\x21-\x7E]*$/,
            message: '半角英数字と記号で入力してください',
          },
          maxLength: {
            value: 60,
            message: '60文字以内で入力してください',
          },
        }}
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            id={id}
            fullWidth
            error={!!error}
            helperText={error?.message}
          />
        )}
      />
    </LabeledField>
  )
}
